module.exports = {
          srcSet: __webpack_public_path__ + "317b48f69be2794f3aa62597c1270685-1359.png"+" 1359w",
          images:[ {path: __webpack_public_path__ + "317b48f69be2794f3aa62597c1270685-1359.png",width: 1359,height: 336}],
          src: __webpack_public_path__ + "317b48f69be2794f3aa62597c1270685-1359.png",
          toString:function(){return __webpack_public_path__ + "317b48f69be2794f3aa62597c1270685-1359.png"},
          
          width: 1359,
          height: 336
        }